import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { FileArchive } from 'lucide-react';

// Bouton "Archives" sur les pages Bilan / Compte de Résultat / Trésorerie.
// Navigation vers /archives/{type} où l'utilisateur peut générer, prévisualiser
// et télécharger les rapports archivés.

export default function DownloadFinancePdfButton({ type, size = 'sm', className = '', testId }) {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate(`/archives/${type}`)}
      variant="outline"
      size={size}
      className={`gap-2 border-indigo-200 text-indigo-700 hover:bg-indigo-50 ${className}`}
      data-testid={testId || `archives-btn-${type}`}
    >
      <FileArchive className="h-4 w-4" /> Rapport mensuel
    </Button>
  );
}
